export default "__VITE_ASSET__Bb51wzUp__"